import React from 'react';

import AppleIcon from '@mui/icons-material/Apple';
import BuildIcon from '@mui/icons-material/Apps';
import GooglePlayIcon from '@mui/icons-material/Google';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PermissionComponent from 'react-redux-permissions';

import SettingsList, { SettingsMenuItem } from '@fd/ui/List/SettingsList';

const configMenuItems: SettingsMenuItem[] = [
  {
    title: 'Mobile_apps_general_settings',
    path: 'mobile-apps/configuration?tab=app-settings',
    icon: <SettingsOutlinedIcon />,
    subtitle: 'Configure_mobile_apps_general_settings',
    searchAlias: ['Mobile apps settings', 'Mobile apps configuration'],
    tagText: 'Flipdish_staff_only',
    permissions: ['FlipdishStaff'],
  },
  {
    title: 'Mobile_apps_app_store_settings',
    path: 'mobile-apps/configuration?tab=app-store',
    icon: <AppleIcon />,
    subtitle: 'Configure_mobile_apps_app_store_settings',
    searchAlias: ['Mobile apps settings', 'Mobile apps configuration'],
    tagText: 'Flipdish_staff_only',
    permissions: ['FlipdishStaff'],
  },
  {
    title: 'Mobile_apps_google_play_settings',
    path: 'mobile-apps/configuration?tab=google-play',
    icon: <GooglePlayIcon />,
    subtitle: 'Configure_mobile_apps_google_play_settings',
    searchAlias: ['Mobile apps google play', 'Google play settings'],
    tagText: 'Flipdish_staff_only',
    permissions: ['FlipdishStaff'],
  },
  {
    title: 'Mobile_apps_start_builds',
    path: 'mobile-apps/configuration?tab=start-builds',
    icon: <BuildIcon />,
    subtitle: 'Configure_mobile_apps_start_builds',
    searchAlias: ['Mobile apps start builds', 'Mobile apps builds'],
    tagText: 'Flipdish_staff_only',
    permissions: ['FlipdishStaff'],
  },
];

export const ConfigurationLinksList = () => {
  return (
    <PermissionComponent allowed={['FlipdishStaff']}>
      <SettingsList menuItems={configMenuItems} />
    </PermissionComponent>
  );
};
